@import "~/styles/variables";

$message-types: "danger", "warning", "info", "success";

.FieldMessage {
  @include font-size("s");
  @include font-weight("semibold");
  margin-top: $space-s;

  @each $type in $message-types {
    &.#{$type} {
      color: map-get($font-colors, $type);
    }
  }
}
